import { useRouter } from 'next/router'

const NavLinks = ({ links, activeLink, setLink }) => {
  const router = useRouter()

  return (
    <ul className='flex text-base mt-28 mb-0'>
      {links.map((link) => (
        <li
          key={link.id}
          className={`text-[#6D6D6D] mr-48 last:mr-0 pb-8 cursor-pointer ${
            link.id === activeLink.id
              ? '!text-black font-semibold border-b-2 border-green'
              : ''
          } relative ${
            !link.completed
              ? "after:content-[''] after:absolute after:top-0 after:right-0 after:bg-[#D93F21] after:h-[8px] after:w-[8px] after:rounded-full after:border after:border-[#D93F21] after:translate-x-16 after:translate-y-4"
              : ''
          }`}
          onClick={() => {
            setLink(link)

            const newPage = Number(link.id)
            router.replace({
              query: { ...router.query, page: newPage.toString() },
            })
          }}
        >
          {link.title}
        </li>
      ))}
    </ul>
  )
}

export default NavLinks
